module.exports = __webpack_public_path__ + "img/hazardEquip25.8fb8f088.png";